import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth22: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '10.6 53.3 16.5 44.6 23 41.1 37.8 41.1 41.2 41.9 44.4 42.1 48.6 41.3 54.7 39.4 60.8 39.4 66.3 39.2 71.2 39.6 73.5 39.8 95.5 46.1 106.5 54.4 109.6 64.3 110.5 77.6 110.5 84.1 110.7 99.8 110.3 109.3 109 117.7 105.4 130.4 98.4 147.3 94.9 151.7 90.2 154.5 89.1 162.7 88.9 168 88.3 171.8 87.7 175.2 86.4 177.7 78.6 182.6 71.4 187.2 65.7 190.4 61.5 191.7 59.2 192.1 53.2 190.6 49 188.3 46.5 185.5 38.2 172.2 34.9 160.8 29.2 146.7 26.8 141.4 20.9 127 16.9 113.1 14 98.7 10.6 83.1 10.6 53.3',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '10.6 53.3 16.5 44.6 23 41.1 37.8 41.1 41.2 41.9 44.4 42.1 48.6 41.3 54.7 39.4 60.8 39.4 66.3 39.2 71.2 39.6 73.5 39.8 95.5 46.1 106.5 54.4 109.6 64.3 110.5 77.6 110.5 84.1 110.7 99.8 110.3 109.3 109 117.7 105.4 130.4 98.4 147.3 94.9 151.7 90.2 154.5 89.1 162.7 88.9 168 88.3 171.8 87.7 175.2 86.4 177.7 78.6 182.6 71.4 187.2 65.7 190.4 61.5 191.7 59.2 192.1 53.2 190.6 49 188.3 46.5 185.5 38.2 172.2 34.9 160.8 29.2 146.7 26.8 141.4 20.9 127 16.9 113.1 14 98.7 10.6 83.1 10.6 53.3',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M76.9,119.1a13.9,13.9 0 1,1 -27.8,0a13.9,13.9 0 1,1 27.8,0',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M10.4,82.7s62,4.9,8.3,38.4l-8.3-38.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M111.2,78.8l-2.4,38s-60.6-24,2.4-38Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.7,142.9l-8.9-21.8-8.3-38.4-.2-29.5,4.4-6.9,8.5-4.9,15,.2,2.6,1.2,3.2-.2,1.6-.8,3.8-.4s2.8,81.8-16.2,113.8l-5.3-12.3Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M90.8,154.8l6.7-6.5,4-8.1,5.1-15.2,2.2-8.1,3-20.4-.6-17.6-2-15.8-3.2-8.3-10.5-8.3-16.4-4.6-4.8-1.6s-.4,89.9,16.4,114.6Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M98.4,147.3l-3.5,4.4-4.7,2.8-1.1,8.2-.2,5.3-.6,3.8-.6,3.4-1.3,2.5-7.8,4.9-7.2,4.6-5.7,3.2-4.2,1.3-2.3.4-6-1.5-4.2-2.3-2.5-2.8-8.3-13.3-3.3-11.4-5.7-14.1-2.4-5.3,3.2,26.5s27.1,70.5,64.5,5.5l3.8-26.1Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '10.6 53.5 13.8 48.7 17.9 44.6 23.8 41.5 38.4 41.4 40.1 42.3 44.7 42.6 46.5 41.4 58.7 39.4 72.5 39.4 81.7 41.5 89.6 44.2 96.7 47.3 104.9 53.7 109.4 64.4 9.9 64.4 10.6 53.5',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'12.6 91.7 25.1 105.5 28.1 82.9 37.8 109.9 45.2 82.9 54.3 111.2 62.7 84.7 71.8 111.2 80 84.3 88.7 111.2 95.4 85 100.5 106.5 110.6 91.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'75 348 61.7 334.5 69.3 325.9 59.1 319.8 71 312.5 59.9 305.9 70.1 299.4 58.9 292.7 69 286.5 57.6 279.7 68 273.3 58.2 267.4 66.8 262.1 56.7 256.2 66 250.5 56.1 244.6 65.8 238.5 56.4 232.9 65.3 227.4 55.9 221.8 67.1 214.9 57.4 209.2 67.1 203.1 57.2 197.2 68.1 190.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'44.3 253.1 48.5 262.3 52.6 252.8 57.4 263.1 62.3 252.8 66.3 263.6 70.9 254.7 74.6 262.3 77.7 253.9 80.7 263.1 83.3 254.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '11.1 92.3 18.3 83.6 29.1 75.4 35.9 72.6 45.5 68.7 52.9 66.5 58.8 66.1 64.6 66.6 71 68.9 77.1 71.2 86.7 76.4 101.1 86.4 108.4 94.4 109.3 100.9 108.9 103.7 107.2 109.4 105.1 114.3 99.5 120.2 93.6 126.2 86.2 132.3 81.5 134.4 76.4 135.1 73.1 138.2 68.9 142.2 65.6 144 58.1 145.2 53.4 145.2 50.2 145 45.5 143.6 39.1 140.5 34.4 137.5 29.5 133 24.6 127.8 16.9 118.1 9.9 111.2 8.2 106.6 7.5 101.7 8.5 96.3 11.1 92.3',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '14.8 87.9 8.5 96.4 8.2 106.5 14.1 115.1 103.8 115.1 107.3 109.1 109.2 102.7 109.3 97.8 108.2 94.4 102 87.7 14.8 87.9',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M14.1,115.1l-5.9-8.6.4-10.1,6.2-8.6s37.7,13-.7,27.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M103.8,115.1l3.4-6,1.9-6.5v-4.8c0,0-1-3.4-1-3.4l-6.2-6.7s-43,12.4,1.8,27.4Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M8.1,106.7l.3-10.3,3.8-6,5.1-5.1,5.1-4.8,6.6-4.6,7.1-3.8,6.6-2.7,5.8-1.9,4.5-.8s1.5-.6,3.5-.6h6.6l7,1.9,7.3,3.3,7.3,3.9,7.8,5.5,8.1,5.7,6.3,5.9,1.7,3.3.8,2v6.7c-.1,0-.9,2.1-.9,2.1,0,0-47.9-13-100.5.5Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M10.5,110.7l12.2,14.7,13.2,13s9.3,5,10.2,5.3,4.3,1.4,4.3,1.4h11.6c0,.1,4.1-1.4,4.1-1.4,0,0,7.5-6.8,7.9-6.8s1.7-2,2.2-2,2.6-.5,3.1-.6,1.9-.1,2.3-.1,10.4-6.5,10.4-6.5l8-7.8,5.3-6.6,2.2-4.3.9-2.8s-51-14-100.5.5l2.4,3.9Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.8,85.3h53.5s-27.4-20.8-53.5,0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'8.2 98.3 21.1 110.2 24.2 90.8 34.1 114 41.8 90.8 51.1 115.1 59.8 92.2 69.1 115.1 77.6 91.9 86.5 115.1 93.5 92.5 98.7 111 109.1 97.7',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '29.3 376.6 38 368.1 42 362.1 49.6 356.1 55.6 351.6 61.8 350.1 67.6 350.6 74.3 351.6 82.4 354.1 87.4 356.3 91.4 357.8 95.1 362.3 98.9 368.6 101.1 374.3 102.6 377.9 108.9 398.4 109.4 406.4 109.9 444.7 108.9 454.2 103.1 467.2 90.6 475 87.1 474.7 66.8 478 60.6 478 53.3 477 47.6 475.2 44 475 39.3 474.5 32.3 474.5 26 473.7 20 472 16 468.2 11.8 464 10 459.7 9.5 454.7 9.7 441.7 11.8 428.7 17.8 405.6 23 390.6 29.3 376.6',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '29.3 376.6 38 368.1 42 362.1 49.6 356.1 55.6 351.6 61.8 350.1 67.6 350.6 74.3 351.6 82.4 354.1 87.4 356.3 91.4 357.8 95.1 362.3 98.9 368.6 101.1 374.3 102.6 377.9 108.9 398.4 109.4 406.4 109.9 444.7 108.9 454.2 103.1 467.2 90.6 475 87.1 474.7 66.8 478 60.6 478 53.3 477 47.6 475.2 44 475 39.3 474.5 32.3 474.5 26 473.7 20 472 16 468.2 11.8 464 10 459.7 9.5 454.7 9.7 441.7 11.8 428.7 17.8 405.6 23 390.6 29.3 376.6',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M47.4,402.8h39.7s-19-89.7-39.7,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.4,403.8l-8.2,35s51-10.1,8.2-35Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M110.2,441.9l.4-36.5s-47.8,22.4-.4,36.5Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M10.9,440.2l-1.1,13.4.5,7.4,2.3,4.2,4.8,5.2,4.8,3.3s3.2.5,3.6.7,4.9-.3,4.9-.3h4.1c0,.1,3.6.4,3.6.4,0,0,3.6.1,4.2.1s2.5.4,2.5.4c0,0,3.4.4,4.1.5s3.8,1,3.8,1l3.7.8s1.2.4,1.6.7,3.7.1,4.4.1,4.4-.1,4.4-.1c0,0,4.2-.7,4.8-.5s5.3-.1,5.8-.1,4.2-.7,5.2-.7,6.2-1,6.2-1c0,0,3-1.2,4-1.4s4.8-2.2,4.8-2.2c0,0,1.4-1.8,2.2-1.9s3.2-2.7,3.3-3.2,1.8-3.8,1.8-3.8l1.9-3.2,1.4-3.4,1-3.8.4-2.6.3-2.7v-2.6c-.1,0-.5-3.7-.5-3.7l-98.7-1.1Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.8,377.5l-7,15.8-4.9,14.2-3.4,15.3-3.2,15.8-1.6,12.5.7,9.3,3.6,6.4s4.2,3.3,4.8,3.8,4.7,3.2,4.7,3.2h5.5c.5,0,5.5.3,6,.4s5.2.7,5.6.7,4.2.1,4.2.1c0,0,.3-79.3-14.9-97.6Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M101.3,376.1l4.8,12.5,2.3,9,1.5,7v6c.1,0,.8,4.8.8,4.8l-.4,19.9-.3,11.5-1.6,9.3-5.5,11.8-11.4,6.4-5.6,1-4.7.7-4,.4s4.7-85,24-100.3Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.3,376.6l8.7-8.5,4-6,13.6-10.5,6.2-1.5,12.5,1.5,8.1,2.5,9,3.7,3.7,4.5,3.8,6.3,3.7,9.3v-17.4s-40.4-40.9-71.5,4.7l-1.8,11.4Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'110.4 424.7 100.5 409.7 95.6 430.7 89 405.1 80.4 431.4 72.5 405.1 63.6 431.1 55.5 405.1 46.6 432.8 39.4 406.5 29.8 432.8 26.9 410.7 14.8 424.2',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'67.5 352.2 78 345.4 66 337.2 76.8 330.1 65.6 322.6 75.8 316 65.8 309.2 75.8 302.8 64.2 295.1 73.9 288.8 64.7 282.7 74.4 276.4 64.4 269.6 74.6 263 65.1 256.6 75.4 250 66.6 244.1 76.6 237.5 66 230.3 77.7 222.7 67.3 215.7 78.9 208.2 68.4 201.1 79.7 193.7 67.5 185.5 78 178.6 73.5 170.6 82.2 168.3 83.4 157',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'96.1 275.1 93 264.8 89.4 275.6 85.5 265.8 80.9 274.8 75.5 264.2 70.5 276.9 64.5 264.8 58.6 276.9 53.6 265.8 48.6 276.6',
			],
		},
	},
};
